var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgPerson = function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10a3.332 3.332 0 100-6.667A3.332 3.332 0 1010 10zm0 1.667c-2.225 0-6.667 1.116-6.667 3.333v.833c0 .459.375.834.834.834h11.666a.836.836 0 00.834-.834V15c0-2.217-4.442-3.333-6.667-3.333z",
    fill: "#332C4A"
  })));
};

export default SvgPerson;